import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { ClaimItemType, ClaimItemTypeEnum } from 'src/app/types/claim-item.type';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ClaimsListItemComponent } from '../claims-list-item/claims-list-item.component';
import { DashboardSessionDetails, SessionsService } from '@services/sessions.service';

@Component({
  selector: 'lv-claims-list',
  templateUrl: './claims-list.component.html',
  styleUrls: ['claims-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, TranslateModule, ClaimsListItemComponent]
})
export class ClaimsListComponent {
  private readonly sessionsService = inject(SessionsService);

  @Input() claimItemType: ClaimItemType = ClaimItemTypeEnum.WaitingReview;
  @Input() sessions: DashboardSessionDetails[];
  dashboardSessionsPerPage = this.sessionsService.dashboardSessionsPerPage;
}
